let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5OUiu")).then(() => parcelRequire('cBLI1'));